<!--
 * @Author: yeqing
 * @Date: 2021-11-24 09:29:13
 * @LastEditTime: 2022-05-25 18:15:11
 * @LastEditors: yeqing
 * @Description: 专精特新企业测评入口
 * @FilePath: \fe-frame-page\src\views\enterpriseSpecial\index.vue
-->
<template>
  <div class="enterpriseSpecial">
    <div class="page_title">
      <a-tabs>
        <a-tab-pane tab="专精特新测评" key="evaluation"></a-tab-pane>
      </a-tabs>
    </div>
    <img src="@/assets/images/check-bg.png" class="bg_img" />
    <div class="bg_box">
      <div class="title">专精特新测评</div>
      <div class="btn_box">
        <div class="smEvaluation-btn">
          <a-button class="btn" @click="onEntrance('smEvaluation')"
            >【专精特新中小企业测评】入口</a-button
          >
          <SelectCity class="select-city" :isShow="isShow" @onClose="isShow = false"/>
        </div>
        <a-button class="btn" @click="onEntrance('littleGiant')"
          >【专精特新小巨人测评】入口（国家级）</a-button
        >
      </div>
    </div>
    <div class="service">
      <div class="title">专精特新 享荣誉 拿补贴</div>
      <div class="list">
        <div v-for="(item, index) in listData" :key="index" class="item">
          <div>
            <svg-icon :icon-class="item.icon" class="icon"></svg-icon>
          </div>
          <div>
            <div class="name">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SvgIcon from "../../components/SvgIcon/index.vue";
import SelectCity from "./components/selectCity.vue";
export default {
  data() {
    return {
      listData: [
        {
          icon: "zjtx_6",
          title: "荣誉资质",
          desc: "获得专精特新证书，大幅度提升企业品牌和硬实力",
        },
        {
          icon: "zjtx_5",
          title: "资金补助",
          desc: "企业最高可获得1500万资金补贴",
        },
        {
          icon: "zjtx_4",
          title: "金融扶持",
          desc: "专精特新企业可优先获得融资服务，享受银行优惠利率",
        },
        {
          icon: "zjtx_3",
          title: "政策扶持",
          desc: "利企政企重点导向，一系列专精特新政策支持中小企业全面发展",
        },
        {
          icon: "zjtx_2",
          title: "北交所上市主力军",
          desc: "专精特新企业为北交所上市的主力军",
        },
        {
          icon: "zjtx_1",
          title: "助力企业腾飞",
          desc: "在技术服务、创新驱动、转型升级、专题培训等方面重点扶持",
        },
      ],
			isShow:false
    };
  },
  components: { SvgIcon, SelectCity },
  methods: {
    onEntrance(name) {
      if (name == "smEvaluation") {
        this.isShow = true;
      } else {
        this.$router.push("/enterpriseSpecial/littleGiant");
      }
    },
  },
  created () {
    sessionStorage.removeItem('basicInfo')
  }
};
</script>
<style lang="less" scoped>
.enterpriseSpecial {
  // padding: 20px;
  background: #fff;
  padding-bottom: 50px;
  position: relative;
  .page_title {
    padding: 0px 20px 20px 20px;
  }
  ::v-deep .ant-tabs-tab-active {
    font-weight: 500;
    color: #333;
    font-size: 16px;
    padding: 15px 0 17px 0;
  }
  ::v-deep .ant-tabs-ink-bar {
    width: 100px !important;
    background: #0072f7;
  }
  .bg_img {
    width: 100%;
    height: auto;
    position: absolute;
    z-index: 0;
  }
  .bg_box {
    width: 100%;
    height: 406px;
    z-index: 9;
    position: relative;
    // background-image: url("~@/assets/images/check-bg.png");
    // background-size: 100% 100%;
    .title {
      // height: 44px;
      font-size: 44px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 44px;
      text-align: center;
      padding-top: 62px;
    }
    .btn_box {
      text-align: center;
      margin-top: 90px;
      display: flex;
      justify-content: center;
      .smEvaluation-btn {
        position: relative;
      }
      .btn {
        width: 300px;
        height: 46px;
        background: #1a90ff;
        border-radius: 3px;
        font-size: 16px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 46px;
        margin: 0;
        padding: 0;
        border: none;
        &:hover {
          background: #5eb1ff;
        }
        &:first-child {
          margin-right: 74px;
          background: #0072f7;
          &:hover {
            background: #59a4ff;
          }
        }
      }
    }
  }
  .service {
    width: 970px;
    margin: 0 auto;
    // width: 100%;
    height: 313px;
    border: 1px solid rgba(0, 114, 247, 0.07);
    margin-top: -30px;
    position: relative;
    // z-index: 9;
    .title {
      height: 20px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      margin: 0 auto;
      text-align: center;
      background: #fff;
      margin-top: -11px;
      width: 210px;
    }
    .list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding-left: 38px;
      .item {
        width: 50%;
        display: flex;
        margin-top: 40px;
        align-items: center;
        .icon {
          width: 40px;
          height: 40px;
          // background-color: #0072f7;
          margin-right: 10px;
        }
        .name {
          height: 14px;
          font-size: 14px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #333333;
          line-height: 14px;
        }
        .desc {
          height: 14px;
          font-size: 14px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #999999;
          margin-top: 14px;
        }
      }
    }
  }
  .select-city {
    position: absolute;
    margin-top: 10px;
    z-index: 99999;
  }
}
</style>
